import React from "react";
import Contact from "./contactoBorrar";
import Skills from "./skills";
import Education from "./education";
import Experience from "./experience";
import Portfolio from "./portfolio";
import Skills2 from "./skills2";
import DentonsPortfolio from "./DentonsPortfolio";


function HomePart1() {
    return (
        <div className="homePart1">
            <div className="containerHome" >
                        
                <div className="text">
                    <img className="fotoNati" src="img/fotocirculo-01.png" alt="Natali Larroza" /> 
        
                    <div className="homeText">
                        <div className>
                            <h3 className="tituloN">Natali Larroza</h3>
                        </div>
                    <div className="infocourse1" >
                        <p>Multimedia Designer</p>
                        <p id="cv">Click <a href="./img/LarrozaNataliCV.pdf" id="style-2" data-replace="here" target="_blank"><span>here</span></a> to Download CV</p>
                    </div>
                </div>
         
                </div>
    </div>

        <div className="aboutMe" >
            <div className="aboutMeTxt ">
                <h1 className="aboutmetxt_"><b>ABOUT ME</b></h1>
                <h2 className="hire">Multimedia & Web Designer</h2>
                <p className="aboutmetxt">
                    I'm a Multimedia Designer and Content Creator passionate about visual storytelling. With a background in Multimedia Design, plus studies in Graphic and Web Design, I blend creativity and technical skill to bring ideas to life through video, motion graphics, photography, and digital design.

I've worked across TV, corporate projects, and freelance collaborations, creating everything from video content and social media campaigns to branding, product photography, and print materials. I love crafting visuals that connect with people and communicate messages in a clear, engaging way.

I also develop websites using React, WordPress, Shopify, and DUDA, focusing on clean design, smooth user experience, and responsive functionality. Whether it’s multimedia, web, or branding, my goal is always the same: to create work that is thoughtful, polished, and tailored to each client.

I'm detail-driven, curious, and always exploring new tools and ideas to keep evolving as a creator.<br />

                    <br />• Creative and effective problem-solving abilities
                    <br />• Proficient in multitasking and achieving goals efficiently and accurately
                    <br />• Proficient in Adobe suite, Microsoft Suite, HTML, CSS, JavaScript, Bootstrap, React, Shopify, WordPress, WooCommerce and DUDA
                    </p> 

            </div>
        </div>


        <Experience />
        <div className="skills">
            <Skills2 />
        </div>
        <Education />
        
        <Portfolio />
       
</div>
    )
};

export default HomePart1;




